export enum LoginSteps {
    Login = 'login',
    Password = 'password',
}

export interface AuthState {
    currentStep: LoginSteps;
    login: string | undefined;
}
